/* eslint-disable no-unused-vars */
import DataTable from '@/containers/data_table_ml/DataTable';
import './TablePage.less';
import ButtonML from '@/components/button_ml/ButtonML';
import { useSelector, useDispatch } from 'dva';
import React, { useState, useEffect, useCallback } from 'react';
import SelectML from '@/components/select_ml/SelectML';
import { toOption } from '@/utils/comUtil.js';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import { conditionMathMap, outputTypeMap } from '@/constants.js';
import ModalML from '@/components/modal_ml/ModalML';
import { useTrigger } from '@/utils/comHook.js';
import styles from './TablePage.less?modules';
import { message } from 'antd';
// import AddFieldPackage from '../../../../../_comm/containers/add_field_package_comm/index';
import AddFieldPackage from '../../../../../_comm/containers/filter_field_package/index';
import Cascader from '@/containers/cascader_ml/cascader_package_ml/CascaderPackage';

const RuleTabel = (props) => {
  const { name, id, form } = props || {};
  const { editable } = props.location.query;
  const dispatch = useDispatch();
  //控制弹框的开关
  const trigger = useTrigger();

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['mdCondition/getMdRuleList'];
  const data = useSelector((state) => state.mdCondition.getMdRuleList);
  const ruleList = data || [];
  const [tabelD, setTabelD] = useState([]);
  const [addIndex, setAddIndex] = useState(1);
  const [curentRecord, setCurentRecord] = useState(''); //当前改变的record
  const [cascaderData, setCascaderData] = useState({});
  const [addOptions, setAddOptions] = useState([]);

  // let i = 0;
  const addRuleList = () => {
    let add = [];
    if (addIndex > 1) {
      message.warning('请点击保存，一条一条填写'); //多条一起填写增加删除会有每次清空的bug
      return;
    }
    for (let j = 0; j < addIndex; j++) {
      add.push({
        modelFieldId: id,
        fieldType: 'INTEGER',
        fieldName: name,
        id: 'null' + j,
      });
    }
    if (ruleList.length >= 0) {
      setTabelD([...ruleList, ...add]);
      setAddIndex(addIndex + 1);
    }
  };
  //改变数组是时候更改是否可以选中状态(更改请求到的数据)
  const onSelectType = (val, record) => {
    let obj = {};
    obj['score-' + record.id] = undefined;
    form.setFieldsValue({
      ...obj,
    });

    let tabelDCopy = JSON.parse(JSON.stringify(tabelD));
    (tabelDCopy || []).forEach((item) => {
      if (item.id === record.id) {
        item.scoreType = val;
        item.score = undefined;
      }
    });
    setTabelD(tabelDCopy);
  };
  const openFilterModal = (record) => {
    trigger.open();
    setCurentRecord(record.id);
  };
  const changeOptions = (list) => {
    const { fieldName, variableName: ids } = list && list.length ? list[0] : {};
    let tabelDCopy = JSON.parse(JSON.stringify(tabelD));
    //只能选一个，因为如果选多个的话就要挂载在每个table上，挂载一个选择数组。目前仅支持单个挂载
    (tabelDCopy || []).forEach((item) => {
      if (item.id === curentRecord) {
        item['score'] = ids;
        item['scoreName'] = fieldName;
      }
    });
    setTabelD(tabelDCopy);
  };
  const fetchTabelData = useCallback(() => {
    if (ruleList instanceof Array) {
      setTabelD([...ruleList]);
    }
    setAddIndex(1); //避免每次增加累计增加虚拟List
  }, [ruleList]);
  useEffect(() => {
    fetchTabelData();
  }, [fetchTabelData]);

  // 获取级联下拉数据
  const fetchPackageData = useCallback(() => {
    dispatch({
      type: 'bre/getAllPackages',
      payload: {},
      callback: (res) => {
        let result = [];
        let cascaderDataUnuse = {};
        res &&
          res.length > 0 &&
          res.forEach((item) => {
            let child = [];
            item.fields &&
              item.fields.forEach((item2) => {
                child.push({
                  // value: item2.id,
                  value: item2.id,
                  label: item2.fieldName,
                });
                cascaderDataUnuse[item2.id] = [item.fieldPackageId, item2.id];
              });
            result.push({
              value: item.fieldPackageId,
              label: item.fieldPackageName,
              children: child,
            });
          });
        setCascaderData(cascaderDataUnuse);
        setAddOptions(result);
      },
    });
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    fetchPackageData();
  }, [fetchPackageData]);

  useEffect(() => {
    let obj = {};
    tabelD.forEach((item) => {
      for (const key in cascaderData) {
        if (item.scoreType === 'VARIABLE' && item.score === key) {
          obj['score-' + item.id] = cascaderData[key];
        }
      }
    });
    form.setFieldsValue({
      ...obj,
    });
  }, [cascaderData, form, tabelD]);
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 50,
      render: (text) => {
        return <span> {typeof text === 'number' ? text : ''}</span>;
      },
    },
    {
      title: '条件名称',
      dataIndex: 'fieldName',
      key: 'fieldName',
      width: 200,
    },
    {
      title: '条件类型',
      dataIndex: 'fieldType',
      key: 'fieldType',
      width: 200,
    },
    {
      title: '运算符',
      dataIndex: 'relationOperator',
      key: 'relationOperator',
      width: 200,
      render: (text, record) => {
        return (
          <SelectML
            height="37px"
            labelwidth="130px"
            inputWidth="180px"
            className={['no_label']}
            placeVal="请选择"
            name={'relationOperator-' + record.id}
            // allowClear={true}
            option={toOption(conditionMathMap)}
            value={text}
            require={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
          />
        );
      },
    },
    {
      title: '值',
      dataIndex: 'compareValue',
      key: 'compareValue',
      width: 200,
      render: (text, record) => {
        return (
          <SingInputML
            height="37px"
            labelwidth="0px"
            inputWidth="100px"
            // labelVal="规则包名"
            placeVal="请输入值"
            className="no_label"
            name={'compareValue-' + record.id}
            value={text}
            require={[
              {
                required: true,
                message: '请输入值',
              },
            ]}
            // allowClear={true}
          />
        );
      },
    },
    {
      title: '系数',
      dataIndex: 'coefficient',
      key: 'coefficient',
      width: 200,
      render: (text, record) => {
        return (
          <SingInputML
            height="37px"
            labelwidth="0px"
            inputWidth="100px"
            // labelVal="规则包名"
            placeVal="请输入值"
            className="no_label"
            name={'coefficient-' + record.id}
            value={text}
            require={[
              {
                required: true,
                message: '请输入数字',
                pattern: new RegExp(/^[1-9]\d*$/, 'g'),
              },
            ]}
            // allowClear={true}
          />
        );
      },
    },
    {
      title: '分值类型',
      dataIndex: 'scoreType',
      key: 'scoreType',
      width: 200,
      render: (text, record) => {
        return (
          <SelectML
            height="37px"
            labelwidth="130px"
            inputWidth="180px"
            className={['no_label']}
            placeVal="请选择"
            name={'scoreType-' + record.id}
            // allowClear={true}
            option={toOption(outputTypeMap)}
            value={text}
            require={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
            onSelect={(val) => onSelectType(val, record)}
          />
        );
      },
    },
    {
      title: '分值',
      dataIndex: 'score',
      key: 'score',
      width: 200,
      render: (text, record) => {
        let opt = {};
        opt[record.score] = record.scoreName;
        return record.scoreType === 'VARIABLE' ? (
          <div className={styles.seled_filter}>
            <Cascader
              height="37px"
              options={addOptions}
              allowClear={true}
              placeVal={'请输入'}
              name={'score-' + record.id}
              value={cascaderData[record.score]}
              form={form}
              className={['mt']}
              require={[
                {
                  required: true,
                  message: '请选择规则包状态',
                },
              ]}
              displayRender={(label) => {
                return String(editable) === 'false'
                  ? label && label[1]
                  : label.join('/');
              }}
            />
          </div>
        ) : (
          <SingInputML
            height="37px"
            labelwidth="0px"
            inputWidth="100px"
            // labelVal="规则包名"
            placeVal="请输入值"
            className="no_label"
            name={'score-' + record.id}
            value={text}
            require={[
              {
                required: true,
                message: '请输入数字',
                pattern: new RegExp(/^[1-9]\d*$/, 'g'),
              },
            ]}
            // allowClear={true}
          />
        );
      },
    },
  ];
  return (
    <>
      <DataTable
        // bordered={true}
        className="demo-test"
        style={{ border: '1px solid #edf0f0' }}
        columns={columns}
        rowSelection={false}
        scroll={{ y: 'calc(100vh - 160px - 3rem)' }}
        dataSource={tabelD}
        loading={loading}
        title={() => (
          <div className="rule_name">
            <span>字段名称</span>
            {name}
          </div>
        )}
        footer={() => (
          <ButtonML
            size="large"
            value="添加输入组"
            htmlType="submit"
            fontsize="16px"
            onClick={() => addRuleList()}
            disabled={String(editable) === 'false'}
          />
        )}
      />
      {/* <ModalML
        title=""
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
      >
        <Ffp handleCancel={trigger.close} changeOptions={changeOptions} />
      </ModalML> */}
      <ModalML
        title="新增"
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
      >
        <AddFieldPackage
          handleCancel={trigger.close}
          changeOptions={changeOptions}
        />
      </ModalML>
    </>
  );
};
export default RuleTabel;
